// import axios from 'axios'
// import React, { useEffect, useState } from 'react'
// import { Container, Row, Col, Form, Button, Modal } from 'react-bootstrap'
// import toast from 'react-hot-toast'
// import Cookies from 'js-cookie'
// import { useNavigate } from 'react-router-dom'

// const Site = ({ onSiteCreated }) => {
//   const [site, setSite] = useState({
//     name: '',
//     area: '',
//     pincode: '',
//     city: '',
//     state: '',
//     site_image: '',
//     address: '',
//     status: '',
//     location: '',
//   })
//   const [showModal, setShowModal] = useState(false)
//   const [error, setError] = useState('')
//   const [loading, setLoading] = useState(false)
//   const navigate = useNavigate()
//   useEffect(() => {
//     // Check for authentication token
//     const token = Cookies.get('authToken')
//     if (!token) {
//       // If token is not found, redirect to login page
//       window.location.href = '/login'
//     }
//   }, [])

//   const validStatus = ['active', 'not active', 'sold']

//   const inputHandler = (e) => {
//     const { name, value } = e.target
//     setSite({ ...site, [name]: value })
//   }

//   const submitForm = async (e) => {
//     e.preventDefault()
//     setError('')
//     setLoading(true)

//     const token = Cookies.get('authToken') // Retrieve token from cookies

//     if (!validStatus.includes(site.status)) {
//       toast.error('Invalid Status selected')
//       setTimeout(() => {
//         window.location.reload()
//       }, 3000)
//       return
//     }
//     try {
//       const response = await axios.post(
//         BASE_URL+'/site/create',
//         site,
//         {
//           headers: {
//             'Content-Type': 'application/json',
//             Authorization: `Bearer ${token}`,
//           },
//         },
//       )
//       // toast.success(response.data.message || 'Customer created successfully ')

//       setShowModal(true)
//       setTimeout(() => {
//         navigate('/sitelists')
//         window.location.reload()
//       }, 3000)
//     } catch (err) {
//       toast.error(
//         err.response?.data.message ||
//           'Failed to create site. Please try again.',
//       )
//       setTimeout(() => {
//         window.location.reload()
//       }, 3000)
//     }
//   }

//   const handleModalClose = () => {
//     setShowModal(false)
//   }
//   return (
//     <Container
//       style={{ maxWidth: '1100px', marginRight: '13.5rem' }}
//       className="mt-0 p-0"
//     >
//       <Form className="text-start m-0  p-0" onSubmit={submitForm}>
//         <h1
//           className="display-6 text-success bg-light fw-bold text-center p-1"
//           style={{ borderBottom: '1px solid gray' }}
//         >
//           Create New Site
//         </h1>
//         <Row>
//           <Col xs={12} md={6} className="mb-3">
//             <Form.Label htmlFor="name">
//               Name
//               <span style={{ fontSize: '1.25rem', marginLeft: '0.25rem' }}>
//                 *
//               </span>
//             </Form.Label>
//             <Form.Control
//               type="text"
//               id="name"
//               name="name"
//               value={site.name}
//               onChange={inputHandler}
//               required
//             />
//           </Col>
//           <Col xs={12} md={6} className="mb-3">
//             <Form.Label htmlFor="area">Site Area</Form.Label>
//             <Form.Control
//               type="text"
//               id="area"
//               name="area"
//               value={site.area}
//               onChange={inputHandler}
//             />
//           </Col>
//         </Row>

//         <Row>
//           <Col xs={12} md={4} className="mb-3">
//             <Form.Label htmlFor="state">
//               State
//               <span style={{ fontSize: '1.25rem', marginLeft: '0.25rem' }}>
//                 *
//               </span>
//             </Form.Label>
//             <Form.Control
//               type="text"
//               id="state"
//               name="state"
//               value={site.state}
//               onChange={inputHandler}
//               required
//             />
//           </Col>
//           <Col xs={12} md={4} className="mb-3">
//             <Form.Label htmlFor="city">
//               City
//               <span style={{ fontSize: '1.25rem', marginLeft: '0.25rem' }}>
//                 *
//               </span>
//             </Form.Label>
//             <Form.Control
//               type="text"
//               id="city"
//               name="city"
//               value={site.city}
//               onChange={inputHandler}
//               required
//             />
//           </Col>

//           <Col xs={12} md={4} className="mb-3">
//             <Form.Label htmlFor="pincode">Pincode</Form.Label>
//             <Form.Control
//               type="text"
//               id="pincode"
//               name="pincode"
//               value={site.pincode}
//               onChange={inputHandler}
//             />
//           </Col>
//         </Row>

//         <Row>
//           <Col xs={12} className="mb-3">
//             <Form.Label htmlFor="address">Address</Form.Label>
//             <Form.Control
//               as="textarea"
//               id="address"
//               name="address"
//               value={site.address}
//               onChange={inputHandler}
//             />
//           </Col>
//         </Row>

//         <Row>
//           <Col xs={12} md={6} className="mb-3">
//             <Form.Label htmlFor="location">Location</Form.Label>
//             <Form.Control
//               type="text"
//               id="location"
//               name="location"
//               value={site.location}
//               onChange={inputHandler}
//             />
//           </Col>
//           <Col xs={12} md={6} className="mb-3">
//             <Form.Label htmlFor="status">
//               Site Status
//               <span style={{ fontSize: '1.25rem', marginLeft: '0.25rem' }}>
//                 *
//               </span>
//             </Form.Label>
//             <Form.Select
//               id="status"
//               name="status"
//               value={site.status}
//               onChange={inputHandler}
//               required
//             >
//               <option>SELECT</option>
//               <option value="active">ACTIVE</option>
//               <option value="not active">NOT ACTIVE</option>
//               <option value="sold">SOLD</option>
//             </Form.Select>
//           </Col>
//         </Row>

//         {error && <div className="alert alert-danger">{error}</div>}
//         <div className="d-grid mt-4 ">
//           <Button
//             type="submit"
//             className="text-white"
//             style={{ backgroundColor: '#198754', border: 'none' }}
//             disabled={loading}
//           >
//             {loading ? 'Creating...' : 'Create New Site'}
//           </Button>
//         </div>
//       </Form>

//       <Modal show={showModal} onHide={handleModalClose} centered>
//         <Modal.Header closeButton>
//           <Modal.Title className="w-100 text-center">
//             Site Created Successfully!
//           </Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <p>
//             The new site has been added to the system successfully. You can now
//             view their details or proceed with the next steps in the process.
//           </p>
//         </Modal.Body>
//         <Modal.Footer>
//           <Button variant="success" onClick={handleModalClose}>
//             Close
//           </Button>
//         </Modal.Footer>
//       </Modal>
//     </Container>
//   )
// }

// export default Site


import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Form, Button, Modal, Card } from 'react-bootstrap'
import toast from 'react-hot-toast'
import Cookies from 'js-cookie'
import { useNavigate } from 'react-router-dom'
import {theme} from '../theme/theme'
import { BASE_URL } from '../constants'


const Site = ({ onSiteCreated }) => {
  const [site, setSite] = useState({
    name: '',
    area: '',
    pincode: '',
    city: '',
    state: '',
    site_image: '',
    address: '',
    status: '',
    location: '',
  })
  const [showModal, setShowModal] = useState(false)
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    const token = Cookies.get('authToken')
    if (!token) window.location.href = '/login'
  }, [])

  const validStatus = ['active', 'not active', 'sold']

  const inputHandler = (e) => {
    const { name, value } = e.target
    setSite({ ...site, [name]: value })
  }

  const submitForm = async (e) => {
    e.preventDefault()
    setError('')
    setLoading(true)
    const token = Cookies.get('authToken')

    if (!validStatus.includes(site.status)) {
      toast.error('Invalid status selected')
      setTimeout(() => window.location.reload(), 3000)
      return
    }

    try {
      await axios.post(BASE_URL+'/site/create', site, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
      })

      setShowModal(true)
      setTimeout(() => {
        navigate('/sitelists')
        window.location.reload()
      }, 3000)
    } catch (err) {
      toast.error(
        err.response?.data.message ||
          'Failed to create site. Please try again.',
      )
      setTimeout(() => window.location.reload(), 3000)
    }
  }

  const handleModalClose = () => setShowModal(false)

  return (
  <Container className="pb-3" style={{fontFamily: theme.font.family }}>

        <Form onSubmit={submitForm}  
        className="mx-auto px-3 py-1"
        style={{
          backgroundColor: theme.colors.background,
      
        }}
      >
        <p
          className="mb-4 fw-bold"
          style={{
            color: theme.colors.primary,
            borderBottom: `2px solid ${theme.colors.secondary}`,
            paddingBottom: '8px',
            fontSize: '1.5rem',
          }}
        >
          Create New Site
        </p>
        
        
          <Row>
            <Col md={6} className="mb-3">
              <Form.Label className="fw-semibold">Site Name *</Form.Label>
              <Form.Control
                type="text"
                name="name"
                value={site.name}
                onChange={inputHandler}
                placeholder="Enter site name"
                required
              />
            </Col>

            <Col md={6} className="mb-3">
              <Form.Label className="fw-semibold">Site Area</Form.Label>
              <Form.Control
                type="text"
                name="area"
                value={site.area}
                onChange={inputHandler}
                placeholder="Enter site area"
              />
            </Col>
          </Row>

          <Row>
            <Col md={4} className="mb-3">
              <Form.Label className="fw-semibold">State *</Form.Label>
              <Form.Control
                type="text"
                name="state"
                value={site.state}
                onChange={inputHandler}
                placeholder="Enter state"
                required
              />
            </Col>

            <Col md={4} className="mb-3">
              <Form.Label className="fw-semibold">City *</Form.Label>
              <Form.Control
                type="text"
                name="city"
                value={site.city}
                onChange={inputHandler}
                placeholder="Enter city"
                required
              />
            </Col>

            <Col md={4} className="mb-3">
              <Form.Label className="fw-semibold">Pincode</Form.Label>
              <Form.Control
                type="text"
                name="pincode"
                value={site.pincode}
                onChange={inputHandler}
                placeholder="Enter pincode"
              />
            </Col>
          </Row>

          <Row>
            <Col xs={12} className="mb-3">
              <Form.Label className="fw-semibold">Address</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="address"
                value={site.address}
                onChange={inputHandler}
                placeholder="Enter complete address"
              />
            </Col>
          </Row>

          <Row>
            <Col md={6} className="mb-3">
              <Form.Label className="fw-semibold">Location</Form.Label>
              <Form.Control
                type="text"
                name="location"
                value={site.location}
                onChange={inputHandler}
                placeholder="Enter Google Maps location"
              />
            </Col>

            <Col md={6} className="mb-3">
              <Form.Label className="fw-semibold">Site Status *</Form.Label>
              <Form.Select
                name="status"
                value={site.status}
                onChange={inputHandler}
                required
              >
                <option value="">Select status</option>
                <option value="active">Active</option>
                <option value="not active">Not Active</option>
                <option value="sold">Sold</option>
              </Form.Select>
            </Col>
          </Row>

          {error && (
            <div className="alert alert-danger text-center">{error}</div>
          )}

          
          <div className="d-grid mt-4">

            <Button
              type="submit"
              className="px-5 py-2 fw-semibold"
              style={{
                backgroundColor: theme.colors.primary,
                border: 'none',
                color: '#fff',
              }}
              disabled={loading}
            >
              {loading ? 'Creating...' : 'Create New Site'}
            </Button>
          </div>
        </Form>
      

      <Modal show={showModal} onHide={handleModalClose} centered>
        <Modal.Header
          closeButton
          style={{ backgroundColor: theme.colors.primary, color: '#fff' }}
        >
          <Modal.Title className="w-100 text-center">
            Site Created Successfully!
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="text-center">
          <p>
            The new site has been added successfully. You can now view it in the
            Site List section.
          </p>
        </Modal.Body>
        <Modal.Footer className="justify-content-center">
          <Button
            onClick={handleModalClose}
            style={{
              backgroundColor: theme.colors.secondary,
              border: 'none',
              color: '#fff',
              padding: '0.5rem 1.5rem',
              borderRadius: '0.5rem',
            }}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  )
}

export default Site
